import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client'
import { setContext } from '@apollo/client/link/context'

const API_HOST = process.env.GATSBY_API_HOST

const httpLink = createHttpLink({
  fetch,
  fetchOptions: {
    credentials: 'omit',
  },
})

// Get the authentication token from local storage if it exists
const authMiddleware = setContext(async (_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = typeof window !== 'undefined' ? localStorage.getItem('auth0Token') : ''

  // return the headers to the context so httpLink can read them
  return {
    uri: `${API_HOST}/api/estimate/graphql`,
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
    },
  }
})

export const client = new ApolloClient({
  link: authMiddleware.concat(httpLink),
  cache: new InMemoryCache(),
})
